import React, { useEffect } from "react";
import { Col, Container } from "reactstrap";

import { BEM } from "helpers/BEM.helper";
import { FetchCard } from "views/common/cards/FetchCard";
import { BackgroundOverlays } from "views/components/atoms/BackgroundOverlays";
import { AddressSetupPageSelectors } from "./AddressSetupPageSelectors";
import { MyResidentialUserProfileController } from "domains/user-management/controllers/MyResidentialUserProfileController/MyResidentialUserProfileController";

const classes = new BEM({
  block: {
    extras: ["d-flex", "justify-content-center"],
    name: "AddressSetupPage",
  },
  elements: [{ name: "logo" }, { name: "spinner" }],
});

export interface AddressSetupPageProps {
  showVerifyContactOptions: () => void;
}

export const AddressSetupPage: React.FC<AddressSetupPageProps> = ({
  showVerifyContactOptions,
}: AddressSetupPageProps) => {
  useEffect(() => {
    document.body.classList.toggle("address-setup-page");
    return () => {
      document.body.classList.toggle("address-setup-page");
    };
  }, []);

  return (
    <div
      className={"beautiful-background"}
      data-cy={AddressSetupPageSelectors.block}
    >
      <Container className={classes.getBlockClassNames()} fluid={true}>
        <Col lg="4" md="6" sm="8">
          <FetchCard
            preTitle={"Address Setup"}
            preTitleSubtext={"Select your community and unit."}
            className="submit-bottom pt-3"
          >
            <MyResidentialUserProfileController
              onSaveUserSuccess={() => {
                showVerifyContactOptions();
              }}
            />
          </FetchCard>
        </Col>
      </Container>
      <BackgroundOverlays />
    </div>
  );
};
